import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FilterStoresComponent } from "./filter-stores.component";
import { SelectModule } from "ng-select";

@NgModule({
  declarations: [FilterStoresComponent],
  imports: [CommonModule, RouterModule, SelectModule, FormsModule],
  exports: [FilterStoresComponent],
})
export class FilterStoresModule {}



// WEBPACK FOOTER //
// /app/src/app/layout/filter-stores/filter-stores.module.ts